export const roleAbbreviations = {
  doctor: "Dr.",
  assistant: "Asst.",
  hygenist: "Hyg.",
  front_desk: "FD"
}

export const txpStatusBadgeColors = {
  complete: 'bg-green-100 text-green-700 border-green-200',
  preparing: 'bg-sky-100 text-sky-700 border-sky-200',
  patient_decision: 'bg-red-100 text-red-600 border-red-200',
  treatment_pending: 'bg-sky-100 text-sky-700 border-sky-200'
};

export const patientDecision = {
  scheduled: { className: 'bg-blue-100 text-blue-600 border-blue-200', state: 'Case Accepted' },
  deferred: { className: 'bg-red-100 text-red-600 border-red-200', state: 'Deferred' }
}

export const getPercentage = (treatments, completedTreatmets) => {
  if (treatments <= 0)
    return 0
  else
    return ((completedTreatmets / (treatments)) * 100).toFixed(0)
}

export const getRemainingAmount = (payment_state, amount_to_pay, paid_amount) => {
  if (payment_state == 'payment_completed')
    return (amount_to_pay - amount_to_pay).toFixed(2)
  else
    return (amount_to_pay - paid_amount).toFixed(2)
}
